<script>
  import { derived } from "svelte/store"
  import { useQuery } from "@sveltestack/svelte-query"
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import Loading from "../../../components/pages/Loading.svelte";
  import ExecutionsList from "./ExecutionsList.svelte";

  const ctx = getAutoMpsProjectContext()

  const pastExecutionsQueryResult = useQuery(`/api/auto-mps/projects/${$ctx.projectId}/executions?direction=past`)

  const executions = derived(pastExecutionsQueryResult, pastExecutionsQueryResult => {
    return pastExecutionsQueryResult.data?.executions ?? []
  })
</script>

{#if $pastExecutionsQueryResult.isLoading}
  <Loading/>
{:else}
  <ExecutionsList executions={executions}/>
{/if}
